import { SpinnerWrapper, AnimatedLoader } from './styled';

const SpinnerParticles = () => (
  <>
    {[...Array(8)].map((x, index) => (
      <div key={index}></div>
    ))}
  </>
);

interface Props {
  variant?: 'small' | 'large';
}

function Spinner({ variant = 'large' }: Props) {
  return (
    <SpinnerWrapper data-variant={variant}>
      <AnimatedLoader>
        <SpinnerParticles />
      </AnimatedLoader>
    </SpinnerWrapper>
  );
}
function AnimatedSpinner() {
  return (
    <AnimatedLoader>
      <SpinnerParticles />
    </AnimatedLoader>
  );
}

export { Spinner, AnimatedSpinner };
